export default {
  'Your win': 'Din vinst',
  'Select skins that you want to take': 'Välj vilka dräkter du vill ta',
  'By price': 'På pris',
  '(Autotrade will receive after 10 minutes)': '(Autohandel tar emot efter 10 minuter)',
  ACCEPT: 'Bekräfta',
  'SELECT ALL': 'SELECT ALL',
};
